import BeforeLoading from './BeforeLoading';
export default BeforeLoading;
